// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `audio-player-wrapper {
  position: relative;
  pointer-events: initial;
}
audio-player-wrapper .audio-player-wrapper.top {
  top: 0;
}
audio-player-wrapper .audio-player-wrapper.bottom {
  bottom: -1px;
}
audio-player-wrapper .audio-player-wrapper.bottom .simple-player {
  padding-bottom: calc(var(--large-spacing) + var(--safe-area-bottom));
}
audio-player-wrapper .audio-player-wrapper.static .audio-timeline {
  border-radius: 16px;
}
audio-player-wrapper .audio-player-wrapper {
  width: 100%;
  color: var(--motes-white);
}
audio-player-wrapper .audio-player-wrapper .audio-timeline {
  position: relative;
  width: 100%;
  height: 5px;
  background: var(--motes-white);
  overflow: hidden;
  cursor: pointer;
}
audio-player-wrapper .audio-player-wrapper .audio-timeline .load-bar, audio-player-wrapper .audio-player-wrapper .audio-timeline .progress-bar {
  position: absolute;
  height: inherit;
  transform-origin: left;
}
audio-player-wrapper .audio-player-wrapper .audio-timeline .load-bar {
  background: #888888;
  transition: 0.5s linear;
}
audio-player-wrapper .audio-player-wrapper .audio-timeline .progress-bar {
  background: var(--upload-background-gradient);
  transition: 0.25s linear;
}
audio-player-wrapper .audio-player-wrapper .audio-timeline.new-media .load-bar, audio-player-wrapper .audio-player-wrapper .audio-timeline.new-media .progress-bar {
  transition: 0s;
}
audio-player-wrapper .audio-player-wrapper .simple-player {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: var(--large-spacing);
  box-sizing: border-box;
  background: var(--motes-black);
  cursor: pointer;
}
audio-player-wrapper .audio-player-wrapper .simple-player label {
  font-weight: bold;
  cursor: pointer;
}
audio-player-wrapper .audio-player-wrapper .simple-player .options {
  display: flex;
  align-items: center;
  column-gap: var(--medium-spacing);
}
audio-player-wrapper .audio-player-wrapper .simple-player .options .skip-button {
  font-size: 24px;
}
audio-player-wrapper .audio-player-wrapper .detailed-player .timestamps {
  display: flex;
  justify-content: space-between;
  color: var(--motes-gray);
  margin-top: var(--mini-spacing);
  pointer-events: none;
}
audio-player-wrapper .audio-player-wrapper .detailed-player .options {
  display: flex;
  align-items: center;
  justify-content: center;
}
audio-player-wrapper .audio-player-wrapper .detailed-player .options button {
  margin: 0 30px;
  font-size: 24px;
  height: 60px;
  width: 60px;
}
audio-player-wrapper .audio-player-wrapper .detailed-player .options .skip-button {
  font-size: 29px;
}
audio-player-wrapper .audio-player-wrapper .detailed-player .options .mini-loading-container {
  font-size: 40px;
}
audio-player-wrapper .audio-player-wrapper .options svg-icon[name=play-rounded] {
  margin-left: 6%;
}
audio-player-wrapper .audio-player-wrapper .options .skip-button.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}
audio-player-wrapper .audio-player-wrapper .options .skip-button:not(:active) {
  animation-name: hoverAnimation;
  animation-duration: 500ms;
}
@keyframes hoverAnimation {
  0% {
    transform: scale(1.05);
    color: var(--motes-gray);
  }
}
audio-player-wrapper .audio-player-wrapper .options .skip-button .svg-icon {
  display: flex;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/motes-media-player/audio-player-wrapper/audio-player-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,uBAAA;AACD;AACI;EACF,MAAA;AACF;AACC;EACC,YAAA;AACF;AACE;EACC,oEAAA;AACH;AAKE;EACC,mBAAA;AAHH;AAOC;EACC,WAAA;EACA,yBAAA;AALF;AAOE;EACC,kBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AALH;AAOG;EACC,kBAAA;EACA,eAAA;EACA,sBAAA;AALJ;AAQG;EACC,mBAAA;EACA,uBAAA;AANJ;AASG;EACC,6CAAA;EACA,wBAAA;AAPJ;AAYI;EACC,cAAA;AAVL;AAeE;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;AAbH;AAeG;EACC,iBAAA;EACA,eAAA;AAbJ;AAgBG;EACC,aAAA;EACA,mBAAA;EACA,iCAAA;AAdJ;AAgBI;EACC,eAAA;AAdL;AAqBG;EACC,aAAA;EACA,8BAAA;EACA,wBAAA;EACA,+BAAA;EACA,oBAAA;AAnBJ;AAsBG;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AApBJ;AAsBI;EACC,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AApBL;AAuBI;EACC,eAAA;AArBL;AAwBI;EACC,eAAA;AAtBL;AA6BG;EACC,eAAA;AA3BJ;AAgCI;EACC,YAAA;EACA,oBAAA;EACA,eAAA;AA9BL;AAkCI;EACC,8BAAA;EACA,yBAAA;AAhCL;AAmCI;EACC;IAAM,sBAAA;IAAwB,wBAAA;EA/BjC;AACF;AAiCI;EACC,aAAA;EACA,eAAA;AA/BL","sourcesContent":["audio-player-wrapper {\n\tposition: relative;\n\tpointer-events: initial;\n\n    .audio-player-wrapper.top {\n\t\ttop: 0;\n\t}\n\t.audio-player-wrapper.bottom {\n\t\tbottom: -1px;\n\n\t\t.simple-player {\n\t\t\tpadding-bottom: calc(var(--large-spacing) + var(--safe-area-bottom));\n\t\t}\n\t}\n\n\t.audio-player-wrapper.static {\n\n\t\t.audio-timeline {\n\t\t\tborder-radius: 16px;\n\t\t}\n\t}\n\n\t.audio-player-wrapper {\n\t\twidth: 100%;\n\t\tcolor: var(--motes-white);\n\n\t\t.audio-timeline {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\theight: 5px;\n\t\t\tbackground: var(--motes-white);\n\t\t\toverflow: hidden;\n\t\t\tcursor: pointer;\n\n\t\t\t.load-bar, .progress-bar {\n\t\t\t\tposition: absolute;\n\t\t\t\theight: inherit;\n\t\t\t\ttransform-origin: left;\n\t\t\t}\n\n\t\t\t.load-bar {\n\t\t\t\tbackground: #888888;\n\t\t\t\ttransition: 0.5s linear;\n\t\t\t}\n\n\t\t\t.progress-bar {\n\t\t\t\tbackground: var(--upload-background-gradient);\n\t\t\t\ttransition: .25s linear;\n\t\t\t}\n\n\t\t\t&.new-media {\n\n\t\t\t\t.load-bar, .progress-bar {\n\t\t\t\t\ttransition: 0s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.simple-player {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\theight: 100%;\n\t\t\tpadding: var(--large-spacing);\n\t\t\tbox-sizing: border-box;\n\t\t\tbackground: var(--motes-black);\n\t\t\tcursor: pointer;\n\n\t\t\tlabel {\n\t\t\t\tfont-weight: bold;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.options {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tcolumn-gap: var(--medium-spacing);\n\n\t\t\t\t.skip-button {\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.detailed-player {\n\n\t\t\t.timestamps {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tcolor: var(--motes-gray);\n\t\t\t\tmargin-top: var(--mini-spacing);\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t.options {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\tbutton {\n\t\t\t\t\tmargin: 0 30px;\n\t\t\t\t\tfont-size: 24px;\n\t\t\t\t\theight: 60px;\n\t\t\t\t\twidth: 60px;\n\t\t\t\t}\n\n\t\t\t\t.skip-button {\n\t\t\t\t\tfont-size: 29px;\n\t\t\t\t}\n\n\t\t\t\t.mini-loading-container {\n\t\t\t\t\tfont-size: 40px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.options {\n\t\t\t// Because of the 'play' icon shape, it does not look centered without margin\n\t\t\tsvg-icon[name=\"play-rounded\"] {\n\t\t\t\tmargin-left: 6%;\n\t\t\t}\n\n\t\t\t.skip-button {\n\n\t\t\t\t&.disabled {\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\tpointer-events: none;\n\t\t\t\t\tcursor: default;\n\t\t\t\t}\n\n\t\t\t\t// Emulate hover / click css (does this look cool?)\n\t\t\t\t&:not(:active) {\n\t\t\t\t\tanimation-name: hoverAnimation;\n\t\t\t\t\tanimation-duration: 500ms;\n\t\t\t\t}\n\n\t\t\t\t@keyframes hoverAnimation {\n\t\t\t\t\t0% {  transform: scale(1.05); color: var(--motes-gray)}\n\t\t\t\t}\n\n\t\t\t\t.svg-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
